<template>
  <ExternalList
      headline="Sponsorships"
      endpoint="/api/v2/content-topic-sponsorships"
      :endpoint-filters="{content_topic_id: contentTopic.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      reorder-endpoint="/api/v2/content-topic-sponsorships/priorities"
      :get-reorder-payload="data => ({content_topic_sponsorships: data})"
      :can-show="() => false"
  >
    <template v-slot:default="{ row: contentTopicSponsorship }">
      <td>
        {{ contentTopicSponsorship.attributes.portal_company_name }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/topics/' + contentTopic.id + '/sponsorships/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {ExternalList},

  props: {
    portal: {
      required: true
    },

    contentTopic: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 20, text: 'Company'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },
}
</script>
